<template>
  <div class="registration" v-gxxt-loading="showLoading">
    <div class="title">同学你好，请完善报名信息，以便我们更好的为您提供服务</div>
    <div>
      <gxxt-input required label="姓名" v-model="userInfo.realName" placeholder="请输入姓名"></gxxt-input>
    </div>
    <div v-if="showPhone">
      <gxxt-input required label="手机号" v-model="userInfo.phone" placeholder="请输入手机号"></gxxt-input>
    </div>
    <div>
      <gxxt-date-time-select
        required
        v-model="userInfo.birthdayObj"
        label="生日"
        placeholder="请设置生日"
        @change="changeBirthday"
      ></gxxt-date-time-select>
    </div>
    <div>
      <gxxt-input required v-model="userInfo.company" label="公司名称" placeholder="请设置公司名称"></gxxt-input>
    </div>
    <div>
      <ios-select
        required
        :sourceData="dataList.job"
        :level="1"
        v-model="userInfo.professionObj"
        label="当前职位"
        placeholder="选择当前职位"
        @change="changeJob"
      >
        <template v-slot:suffix>
          <i class="iconfont icon-gengduoyonghu"></i>
        </template>
      </ios-select>
    </div>
    <div>
      <ios-select
        required
        :sourceData="dataList.industry"
        :level="3"
        separation="-"
		:relation="[1, 1]"
        v-model="userInfo.industryObj"
        label="所属行业"
        placeholder="选择所属行业"
        @change="changeIndustry"
      >
        <template v-slot:suffix>
          <i class="iconfont icon-gengduoyonghu"></i>
        </template>
      </ios-select>
    </div>
    <div>
      <gxxt-area-select
        required
        v-model="userInfo.cityObj"
        placeholder="选择所在城市"
        label="所在城市"
        @change="changeCity"
      ></gxxt-area-select>
    </div>
    <div>
      <ios-select
        required
        :sourceData="dataList.revenue"
        :level="1"
        v-model="userInfo.revenueObj"
        label="营收规模"
        placeholder="选择营收规模"
        @change="changeRevenue"
      >
        <template v-slot:suffix>
          <i class="iconfont icon-gengduoyonghu"></i>
        </template>
      </ios-select>
    </div>
    <div>
      <ios-select
        required
        :sourceData="dataList.scale"
        v-model="userInfo.personnelObj"
        :level="1"
        label="人员规模"
        placeholder="选择人员规模"
        @change="changeScale"
      >
        <template v-slot:suffix>
          <i class="iconfont icon-gengduoyonghu"></i>
        </template>
      </ios-select>
    </div>
    <div class="footer-box" @click="submitBtn">
      <gxxt-button type="primary" style="width: 100%">提交</gxxt-button>
    </div>
  </div>
  <!-- <registration-res v-else></registration-res> -->
</template>
<script>
import {
  GxxtInput,
  GxxtButton,
  GxxtAreaSelect,
  GxxtDateTimeSelect,
} from '@/components'
import { setShareInfo } from '@/utils/storage'
import { wxShare } from '@/utils/wx-config'
import RegistrationRes  from './registration-res.vue'
export default {
  components: {
    GxxtInput,
    GxxtButton,
    GxxtAreaSelect,
    RegistrationRes,
    GxxtDateTimeSelect,
  },
  props: {
    showPhone: {
      type: Boolean,
      default: true,
    },
    //来源APP h5
    origin: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      showLoading: true,
      userInfo: {
        realName: '',
        mobile: '',
        birthday: '',
        birthdayObj: [],
        company: '',
        professionStr: '',
        professionObj: [],
        industryStr: '',
        industryObj: [],
        city: '',
        cityObj: [],
        revenueStr: '',
        revenueObj: [],
        personnelStr: '',
        personnelObj: [],
      },
      dataList: {
        industry: [], //行业
        scale: [], //规模
        job: [], //职位
        revenue: [], //营收
      },
      showRecordRes: false,
    }
  },
  computed: {
    address() {
      return (
        this.userInfo.province +
        '-' +
        this.userInfo.city +
        '-' +
        this.userInfo.county
      )
    },
  },
  created() {
    this.userLoginInfo()
    this.openShare()
    this.getProfessionNew()
    this.getIndustryNew()
    this.getPersonnel()
    this.getRevenue()
  },
  methods: {
    async userLoginInfo() {
      this.showLoading = true
      let res = await this.api.login.userLoginInfo()
      this.showLoading = false
      if (res && res.code == 200) {
        this.userInfo = res.data
        this.userInfo.phone = this.userInfo.phone
          ? this.userInfo.phone
          : this.userInfo.mobile
        this.initUserInfo()
      }
    },
    initUserInfo() {
      this.userInfo.birthdayObj = this.splitSelectValue(
        this.userInfo.birthday,
        '-'
      )
      this.userInfo.professionObj = this.splitSelectValue(
        this.userInfo.professionStr
      )
      this.userInfo.industryObj = this.splitSelectValue(
        this.userInfo.industryStr,
        '-'
      )
      this.userInfo.cityObj = this.splitSelectValue(this.userInfo.city)
      this.userInfo.revenueObj = this.splitSelectValue(this.userInfo.revenueStr)
      this.userInfo.personnelObj = this.splitSelectValue(
        this.userInfo.personnelStr
      )
    },
    splitSelectValue(v, sep = ' ') {
      if (typeof v != 'string') return
      let arr = v.split(sep)
      let res = []
      arr.forEach((a, i) => {
        res.push({
          id: i + 1,
          value: a,
        })
      })
      return res
    },
    openShare() {
      let shareInfo = {
        title: '报名信息收集表单',
        desc: '同学你好，请务必完善报名信息，以便我们更好的为您提供服务',
        link: window.location.href,
        imgUrl: this.constants.logo,
      }
      setShareInfo(shareInfo)
      wxShare({
        shareInfo,
      })
    },
    //获取职业/职位
    async getProfessionNew() {
      let res = await this.api.registration.getProfessionNew()
      if (res && res.code == 200) {
        this.dataList.job = res.data
        this.dataList.job.map((item) => {
          item.id = item.code
          item.value = item.name
        })
      }
    },

    //获取行业信息
    async getIndustryNew() {
      let res = await this.api.registration.getIndustryNew()
      if (res && res.code == 200) {
        let one = [],
          two = [],
          three = []
        res.data.map((item) => {
          let obj = {
            id: item.code,
            value: item.name,
            parentId: 0,
          }
          one.push(obj)
          item.child.map((cur) => {
            let obj = {
              id: cur.code,
              value: cur.name,
              parentId: cur.parentCode,
            }
            two.push(obj)
            cur.child.map((i) => {
              let obj = {
                id: item.code,
                value: i.name,
                parentId: i.parentCode,
              }
              three.push(obj)
            })
          })
        })
        this.dataList.industry.push(one, two, three)
      }
    },
    //营收规模
    async getRevenue() {
      let res = await this.api.registration.getRevenue()
      if (res && res.code == 200) {
        this.dataList.revenue = res.data
        this.dataList.revenue.map((item) => {
          item.id = item.code
          item.value = item.name
        })
      }
    },
    //获取人员规模
    async getPersonnel() {
      let res = await this.api.registration.getPersonnel()
      if (res && res.code == 200) {
        this.dataList.scale = res.data
        this.dataList.scale.map((item) => {
          item.id = item.code
          item.value = item.name
        })
      }
    },
    validate() {
      let user = this.userInfo
      if (
        !user.birthday ||
        !user.city ||
        !user.company ||
        !user.industryStr ||
        !user.personnelStr ||
        !user.professionStr ||
        !user.realName ||
        !user.revenueStr ||
        (this.showPhone && !user.phone)
      ) {
        this.$toaster({
          message: '请完善全部信息后提交！',
          duration: 1000,
          show: true,
        })
        return false
      } else {
        return true
      }
    },
    //提交信息列表
    async submitBtn() {
      if (!this.validate()) return
      let res = await this.api.registration.collectUserInfo(this.userInfo)
      if (res && res.code == 200) {
		  this.$emit('confirm', this.userInfo)
      }
    },
    makeSelectStr(v, sep = ' ') {
      let str = ''
      v.forEach((it, index) => {
        if (index > 0) str += sep
        str += it.value
      })
      return str
    },
    changeBirthday(v) {
      this.userInfo.birthday = this.makeSelectStr(v, '-')
    },
    changeJob(v) {
      this.userInfo.professionStr = this.makeSelectStr(v)
    },
    changeIndustry(v) {
      this.userInfo.industryStr = this.makeSelectStr(v, '-')
    },
    changeCity(v) {
      this.userInfo.city = this.makeSelectStr(v)
    },
    changeRevenue(v) {
      this.userInfo.revenueStr = this.makeSelectStr(v)
    },
    changeScale(v) {
      this.userInfo.personnelStr = this.makeSelectStr(v)
    },
  },
}
</script>

<style scoped lang="less">
.registration {
  padding: 0 32px;
  background: #fff;

  .title {
    width: 750px;
    height: 66px;
    line-height: 66px;
    margin-left: -32px;
    background: #ffefdd;
    font-size: 26px;
    color: #cf834e;
    margin-bottom: 12px;
  }

  .icon-gengduoyonghu {
    color: #cccccc;
  }

  .footer-box {
    width: 750px;
    padding: 0 32px;
    box-sizing: border-box;
    position: fixed;
    bottom: 30px;
    left: 50%;
    margin-left: -375px;
  }
}
</style>
